import { useGetOnMount } from 'hooks/useGetOnMount';
import { ACCOUNT_API_EVENT_LOG } from 'apiRoutes';
import { AuditLogTable } from 'components/common/AuditLogTable/AuditLogTable';
import { auditLogTableColumns } from 'components/common/AuditLogTable/auditLogTableColumns';
import { FunctionComponent, useMemo, useState } from 'react';
import { SubscriptionUpdatedDetailsModal } from './SubscriptionUpdatedDetailsModal/SubscriptionUpdatedDetailsModal';

export const SubscriptionAuditLog: FunctionComponent<{
	subscriptionId: string;
}> = ({ subscriptionId }) => {
	const { data, status } = useGetOnMount(
		`${ACCOUNT_API_EVENT_LOG}/GetEvents?subscriptionId=${subscriptionId}`,
	);

	const [showModal, setShowModal] = useState(false);
	const [selectedEventData, setSelectedEventData] = useState<any>(null);

	const columns = useMemo(
		() => [
			auditLogTableColumns.time(),
			auditLogTableColumns.message(),
			auditLogTableColumns.admin(),
			auditLogTableColumns.account(),
			auditLogTableColumns.comment(),
			auditLogTableColumns.details(undefined, (data: any) => {
				setSelectedEventData(data);
				setShowModal(true);
			}),
		],
		[data],
	);

	return (
		<>
			<AuditLogTable
				requestStatus={status}
				data={data}
				columns={columns}
			/>
			<SubscriptionUpdatedDetailsModal
				isOpen={showModal}
				onClose={() => setShowModal(false)}
				eventData={selectedEventData}
			/>
		</>
	);
};
